import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

const Seo = ({
  title,
  metaDescription,
  noIndex,
  location,
  ogImage: ogImageOverride,
}) => {
  const {
    site: {
      siteMetadata: { title: siteName },
    },
    contentfulSitewide: { facebookLink, twitterXLink, defaultOpenGraphImage },
  } = useStaticQuery(graphql`
    query SeoQuery {
      site {
        siteMetadata {
          title
        }
      }
      contentfulSitewide {
        facebookLink {
          ...LinkFragment
        }
        twitterXLink {
          ...LinkFragment
        }
        defaultOpenGraphImage {
          ...SeoOgImageFragment
        }
      }
    }
  `);

  const ogImage = ogImageOverride || defaultOpenGraphImage;

  return (
    <Helmet>
      <html lang="en-GB" />
      <title>
        {title} | {siteName}
      </title>
      {metaDescription && <meta name="description" content={metaDescription} />}
      {noIndex && <meta name="robots" content="noindex, follow" />}
      <meta property="og:locale" content="en_GB" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={`${title} | ${siteName}`} />
      {metaDescription && (
        <meta property="og:description" content={metaDescription} />
      )}
      <meta
        property="og:url"
        content={process.env.GATSBY_SITE_URL + location.pathname}
      />
      <meta property="og:site_name" content={siteName} />
      <meta property="article:publisher" content={facebookLink.url} />
      <meta
        property="og:image"
        content={ogImage.gatsbyImageData.images.fallback.src}
      />
      <meta property="og:image:width" content={ogImage.gatsbyImageData.width} />
      <meta
        property="og:image:height"
        content={ogImage.gatsbyImageData.height}
      />
      <meta property="og:image:type" content={ogImage.mimeType} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:site"
        content={twitterXLink.url.replace('https://twitter.com/', '@')}
      />
    </Helmet>
  );
};

export default Seo;

export const SeoOgImageFragment = graphql`
  fragment SeoOgImageFragment on ContentfulAsset {
    gatsbyImageData(width: 1200, height: 630)
    mimeType
  }
`;
